import { useState, useEffect, useRef } from 'react'
import { useUpdateEffect } from 'ahooks'
import { uniqBy } from 'lodash'
import fileIcon from './img/file-icon.svg'
import {
    fileSizeFormat,
    getFileType,
    getImageDimensions,
    getVideoInfo,
} from '@gatherstar/utils'
import FileProcess from './FileProcess'
import { IconFont } from '../IconFont'
import { Typography } from 'antd'

export const UploadFileList = ({
    fileList,
    onSuccess,
    onError,
    upload,
    allowClear,
}) => {
    const [list, setList] = useState([])
    // 加入状态列表防止频繁操作文件列表大对象
    const [statusList, setStatusList] = useState([])
    useEffect(() => {
        if (fileList && fileList.length > 0) {
            // 将新文件列表追加到现有列表中，保持原数据不变
            setList(
                uniqBy(
                    [
                        ...list,
                        ...fileList.map((item) => ({
                            file: item,
                            id: `${item.name}${item.size}`,
                        })),
                    ],
                    'id',
                ),
            )
        }
    }, [fileList])
    useUpdateEffect(() => {
        setStatusList(
            list.map((item) => {
                const statusItem = statusList.find((it) => it.id === item.id)
                if (statusItem) {
                    return statusItem
                }
                return {
                    id: item.id,
                    fileName: item.file.name,
                    fileSize: item.file.size,
                    status: 'loading',
                }
            }),
        )
    }, [list])
    useUpdateEffect(() => {
        statusList.forEach((item) => {
            if (item.status === 'loading') {
                const file = list.find((file) => file.id === item.id)?.file
                setStatusList((prev) => {
                    const fileIndex = statusList.findIndex(
                        (statusItem) => statusItem.id === item.id,
                    )
                    if (fileIndex !== -1) {
                        const newList = [...statusList]
                        newList[fileIndex].status = 'uploading'
                        return newList
                    }
                    return prev
                })
                upload(file)
                    .then(({ url, dimensions, ...rest }) => {
                        setStatusList((prev) => {
                            const fileIndex = statusList.findIndex(
                                (statusItem) => statusItem.id === item.id,
                            )
                            if (fileIndex !== -1) {
                                const newList = [...statusList]
                                newList[fileIndex] = {
                                    ...newList[fileIndex],
                                    ...rest,
                                    status: 'success',
                                    url,
                                    dimensions: dimensions,
                                }
                                return newList
                            }
                            return prev
                        })
                    })
                    .catch((err) => {
                        setStatusList((prev) => {
                            const fileIndex = statusList.findIndex(
                                (statusItem) => statusItem.id === item.id,
                            )
                            if (fileIndex !== -1) {
                                const newList = [...statusList]
                                newList[fileIndex].status = 'error'
                                newList[fileIndex].error = err
                                return newList
                            }
                            return prev
                        })
                    })
            }
        })
        onSuccess?.(statusList.filter((item) => item.status === 'success'))
        const errorList = statusList.filter((item) => item.status === 'error')
        if (errorList.length > 0) {
            onError?.(errorList)
            setList((prev) =>
                prev.filter((file) => {
                    return !errorList.find((errItem) => errItem.id === file.id)
                }),
            )
            setStatusList((prev) =>
                prev.filter((file) => {
                    return !errorList.find((errItem) => errItem.id === file.id)
                }),
            )
        }
        console.log('statusList', statusList)
    }, [statusList])
    const delFile = (id) => {
        setList((prev) => prev.filter((file) => file.id !== id))
        setStatusList((prev) => prev.filter((file) => file.id !== id))
    }
    return (
        <div className="w-full flex flex-col">
            {statusList
                .filter((item) => item.status !== 'error')
                .map((item, index) => (
                    <div
                        key={`${item.fileName}${item.fileSize}`}
                        className="mb-[8px]"
                    >
                        <div className="flex items-center justify-between p-[16px] border border-solid border-[#EEE] rounded-[8px]">
                            <div className="flex items-center">
                                <img
                                    src={fileIcon}
                                    className="w-[40px] h-[40px]"
                                ></img>
                                <div className="flex flex-col ml-[16px]">
                                    <Typography.Paragraph
                                        ellipsis={{ tooltip: item.fileName }}
                                        className="w-[200px] text-[#111] font-14 font-medium !mb-0"
                                    >
                                        {item.fileName}
                                    </Typography.Paragraph>
                                    <div className="flex items-center font-12 text-[#5D5D5D] mt-[4px]">
                                        {item.dimensions && (
                                            <div className="mr-[4px]">
                                                {item.dimensions} ·{' '}
                                            </div>
                                        )}
                                        <div className="mr-[4px]">
                                            {fileSizeFormat(item.fileSize)}
                                        </div>
                                        {item.status === 'uploading' && (
                                            <div className="flex items-center text-[#111]">
                                                <IconFont
                                                    type="icon-spinner"
                                                    className="!text-[#0077FD] mr-[4px]"
                                                ></IconFont>
                                                正在上传
                                            </div>
                                        )}
                                        {item.status === 'success' && (
                                            <div className="flex items-center text-[#111]">
                                                <IconFont
                                                    type="icon-confirm"
                                                    className="!text-[#0077FD] mr-[4px]"
                                                ></IconFont>
                                                上传成功
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <style>
                                {`.upload-btn-custom-before::before { color: red; }`}
                            </style>
                            <div>
                                {allowClear && (
                                    <IconFont
                                        type="icon-waste"
                                        className="upload-btn-custom-before font-14 cursor-pointer"
                                        onClick={() => delFile(item.id)}
                                    ></IconFont>
                                )}
                            </div>
                        </div>
                        <FileProcess status={item.status}></FileProcess>
                    </div>
                ))}
        </div>
    )
}
